/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestEventsLookup } from '../../models/harvest-events-lookup';
import { MillDto } from '../../models/mill-dto';

export interface AddMill$Params {
      body: MillDto
}

export function addMill(http: HttpClient, rootUrl: string, params: AddMill$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventsLookup>> {
  const rb = new RequestBuilder(rootUrl, addMill.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestEventsLookup>;
    })
  );
}

addMill.PATH = '/api/harvesteventslookup/harvestevents/addMill';
